import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PatientProvider } from '../../providers/patient/patient';

@Component({
  selector: 'adherence-call-dialog',
  templateUrl: 'adherence-call-dialog.html'
})
export class AdherenceCallDialogComponent implements OnInit {

  form: FormGroup;
  program_id: string;
  patient: string;
  user: any;
  doses: any[] = [];

  constructor(
    private db: PatientProvider,
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<AdherenceCallDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.doses = data.doses;
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      callnumber: [null, Validators.required],
      date: [null, Validators.required],
      outcome: [null, Validators.required],
      dose: [null],
      bp_systolic: [null],
      bp_diastolic:  [null],
      notes: [null, Validators.required]
    })
    this.form.controls['date'].setValue(new Date());
  }

  ngOnDestroy() {
    console.log('Leaving adherence call dialog');
  }

  submit() {
    let callreport = this.form.value;
    this.dialogRef.close(callreport);
  }
}



// WEBPACK FOOTER //
// ./src/components/adherence-call-dialog/adherence-call-dialog.ts